import { Skeleton } from "@/components/ui/skeleton";

const SidebarSkeleton = () => {
  return (
    <div className="p-0 lg:px-[15px] lg:pb-[15px] rounded-20 overflow-hidden border border-gray5 bg-white lg:overflow-auto lg:border-0 lg:rounded-none">
      <div className="pr-[8px] py-6 lg:max-h-230 relative">
        <div className="pr-[10px] overflow-auto pl-[16px] sidebar">
          <div className="flex justify-end pb-3 cursor-pointer sticky top-[-1px] z-[1] bg-white">
            <Skeleton className="w-[100px] h-[16px]" />
          </div>
          <div className="mb-3">
            <Skeleton className="w-[120px] h-[20px] mb-2" />
            <div className="border-gray-200 border my-[10px] mb-[15px] rounded-[10px] py-2 px-3">
              {[...Array(3)].map((_, index) => (
                <div
                  key={index}
                  className="flex items-center justify-between py-[7px]"
                >
                  <Skeleton className="w-[20px] h-[20px] rounded-sm" />
                  <Skeleton className="w-[120px] h-[16px]" />
                  <Skeleton className="w-[30px] h-[16px]" />
                </div>
              ))}
            </div>
          </div>
          <div className="mb-4">
            <Skeleton className="w-[120px] h-[20px] mb-2" />
            <div className="pl-3 pr-2">
              {[...Array(2)].map((_, index) => (
                <div
                  key={index}
                  className="flex items-center justify-between py-[7px]"
                >
                  <Skeleton className="w-[20px] h-[20px] rounded-sm" />
                  <Skeleton className="w-[160px] h-[16px]" />
                </div>
              ))}
            </div>
          </div>
          <div className="mb-3">
            <Skeleton className="w-[120px] h-[20px] mb-2" />
            <Skeleton className="w-full h-[44px] mb-3" />
            <div className="border-gray-200 border my-[10px] mb-[15px] rounded-[10px] py-2 px-3">
              {[...Array(3)].map((_, index) => (
                <div
                  key={index}
                  className="flex items-center justify-between py-[7px]"
                >
                  <Skeleton className="w-[20px] h-[20px] rounded-sm" />
                  <Skeleton className="w-[120px] h-[16px]" />
                  <Skeleton className="w-[30px] h-[16px]" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SidebarSkeleton;